let sdkPromise = null

export function loadSdk(src) {
  if (window.Aliplayer) return Promise.resolve(window.Aliplayer)
  if (sdkPromise) return sdkPromise

  sdkPromise = new Promise((resolve, reject) => {
    let script = document.getElementById('playerScriptTag')
    const isNew = !script
    if (isNew) {
      script = document.createElement('script')
      script.id = 'playerScriptTag'
      script.src = src
      script.async = true
    }

    const cleanup = () => {
      clearTimeout(timer)
      script.removeEventListener('load', onLoad)
      script.removeEventListener('error', onError)
    }
    const onError = () => {
      cleanup()
      if (script.parentNode) script.parentNode.removeChild(script)
      reject(new Error('播放器 SDK 加载失败，请检查网络后重试'))
    }
    const onLoad = () => {
      if (!window.Aliplayer) return onError()
      cleanup()
      resolve(window.Aliplayer)
    }
    const timer = setTimeout(onError, 30000)
    script.addEventListener('load', onLoad)
    script.addEventListener('error', onError)
    if (isNew) document.head.appendChild(script)
  }).catch(error => {
    sdkPromise = null
    throw error
  })

  return sdkPromise
}
